var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.97211 8.00065L10.9861 6.35744M7.97211 8.00065L4.98606 6.35744M7.97211 8.00065L8 11.334M7.42711 1.61351L2.50392 4.42632C2.19231 4.60436 2 4.93572 2 5.2946V10.7013C2 11.0631 2.19537 11.3966 2.51089 11.5736L7.54335 14.3956C7.84469 14.5646 8.2119 14.5661 8.51458 14.3995L13.4821 11.6659C13.8016 11.4901 14 11.1544 14 10.7898V5.3026C14 4.93945 13.8031 4.60484 13.4857 4.42847L8.40888 1.60765C8.10312 1.43776 7.73082 1.43998 7.42711 1.61351Z",
    stroke: "#111111",
    strokeOpacity: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlock);
export default __webpack_public_path__ + "static/media/block.baa33b59ab376db43f33484f5886b60a.svg";
export { ForwardRef as ReactComponent };